import { useTheme } from "@emotion/react";
import React, { useEffect } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { LightTooltip } from "../../../../kit/LightToolTip";
import MUITextField from "@mui/material/TextField";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { updateAlertInfo } from "../../../../redux/slice/userSlice";
import { useDispatch } from "react-redux";
import { checkAppUrlUnique } from "../../../../services/api";
import CircularProgress from "@mui/material/CircularProgress";

function InputField({
  label,
  type,
  value,
  isRequired = false,
  isDisabled = false,
  placeHolder = "",
  info = "",
  onChange,
  componentId,
  categoryId,
  prefix,
  suffix,
  isTextBoxRequired = false,
  prefilledValue,
}) {
  const theme = useTheme();

  // loading, success, error, noData
  const [status, setStatus] = React.useState(() => {
    return "noData";
    // if (value === "") {
    //   return "noData";
    // }
    // return "loading";
  });

  const dispatch = useDispatch();

  const checkInputUniqueness = async (value) => {
    const payload = {
      application_name: value,
      request_id: "",
    };
    try {
      const resp = await checkAppUrlUnique({
        payload: payload,
      });

      const statusCode = resp?.data?.status?.statusCode;
      const message = resp?.data?.status?.statusMessage;
      if (statusCode === 200) {
        const response_data = resp.data?.data;
        if (response_data?.isValid) {
          setStatus("success");
        } else {
          setStatus("failed");
        }
      } else {
        dispatch(
          updateAlertInfo({
            message: message,
            open: true,
            severity: "error",
          })
        );
        setStatus("failed");
      }
    } catch (err) {
      console.error("Error", err);
      setStatus("failed");
    }
  };

  useEffect(() => {
    if (
      value !== "" &&
      [
        // "Application URL",
        // "Application Handle",
        // "Frontend Repos Name",
        // "Backend Repos Name",
      ].includes(label) &&
      isDisabled === false
    ) {
      let timeoutId = null;
      setStatus("loading");
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        checkInputUniqueness(value);
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [value]);
  return (
    <div>
      <div
        style={{
          fontSize: theme.size[12],
          fontWeight: theme.fontWeight[500],
          color: theme.palette.rapidInfra.text,
        }}
      >
        {label}

        {isRequired && (
          <span
            style={{ color: theme.palette.rapidInfra.required, marginLeft: 5 }}
          >
            *
          </span>
        )}
        {info && (
          <LightTooltip
            title={info}
            placement={label === "LeanIX id" ? "top-end" : "top"}
            arrow
            sx={{
              "& .MuiTooltip-tooltip": {
                padding: "8px 12px", // Adjust padding if needed
              },
            }}
          >
            <InfoOutlinedIcon
              style={{
                fontSize: theme.size[14],
                color: theme.palette.rapidInfra.infoIcon,
                marginLeft: 5,
                cursor: "pointer",
              }}
            />
          </LightTooltip>
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: theme.size[8],
        }}
      >
        {prefix !== "" && (
          <span
            style={{
              fontSize: theme.size[14],
              fontWeight: theme.fontWeight[500],
              marginRight: theme.size[8],
              color: theme.palette.rapidInfra.text,
            }}
          >
            {prefix}
          </span>
        )}

        {isTextBoxRequired ? (
          <MUITextField
            multiline
            value={value}
            placeholder={placeHolder}
            disabled={isDisabled}
            onChange={(e) => {
              onChange(categoryId, componentId, e.target.value);
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                flex: 1,
                padding: `${theme.size[8.5]} ${theme.size[13]}`,
                fontSize: theme.size[13],
                color: theme.palette.form.text,
                backgroundColor: theme.palette.form.fieldBackground,
              },
              "& .MuiOutlinedInput-input": {
                height: "100px !important",
              },
              "&.MuiTextField-root": {
                backgroundColor: theme.palette.grey[4],
                width: "100%",
                height: "100%",
                borderRadius: theme.size[4],
                fontFamily: theme.typography["fontFamily"],
                "&:hover": {
                  borderColor: "transparent",
                },
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent !important",
              },
            }}
          />
        ) : (
          <input
            type={"text"}
            value={value}
            required={isRequired}
            placeHolder={placeHolder}
            disabled={isDisabled}
            onChange={(e) => {
              if (label === "Number Of Users") {
                if (/^\d*$/.test(e.target.value)) {
                  onChange(categoryId, componentId, e.target.value);
                }
              } else {
                onChange(categoryId, componentId, e.target.value);
              }
            }}
            className="custom-input"
            style={{
              width: "100%",
              padding: "8.5px 8px",
              borderRadius: theme.size[5],
              border: "none",
              outline: "none",
              fontSize: theme.size[14],
              backgroundColor: theme.palette.rapidInfra.inputBackground,
              fontWeight: theme.fontWeight[400],
              fontFamily: theme.typography["fontFamily"],
              color: isDisabled
                ? theme.palette.rapidInfra.textDisabled
                : theme.palette.rapidInfra.text,
            }}
          />
        )}

        {suffix !== "" && (
          <span
            style={{
              fontSize: theme.size[14],
              fontWeight: theme.fontWeight[500],
              marginLeft: theme.size[8],
              color: theme.palette.rapidInfra.text,
            }}
          >
            {suffix}
          </span>
        )}

        {isDisabled ? null : status === "loading" && value !== "" ? (
          <CircularProgress
            sx={{
              marginLeft: theme.size[8],
              height: "16px !important",
              width: "16px !important",
              color: theme.palette.secondary.main,
            }}
          />
        ) : status === "success" && value !== "" ? (
          <div
            style={{
              background: theme.palette.rapidInfra.success,
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: theme.size[8],
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
              border: `1px solid ${theme.palette.rapidInfra.success}`,
            }}
          >
            <DoneIcon sx={{ fontSize: "18px", color: "#fff" }} />
          </div>
        ) : status === "failed" && value !== "" ? (
          <div
            style={{
              background: theme.palette.rapidInfra.failed,
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: theme.size[8],
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
              border: `1px solid ${theme.palette.rapidInfra.failed}`,
            }}
          >
            <CloseIcon sx={{ fontSize: "18px", color: "#fff" }} />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default InputField;
